import type { VariantProps } from "class-variance-authority";

import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-lg font-jakarta font-semibold text-base ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none",
  {
    compoundVariants: [
      {
        className:
          "border-2 border-new-beginnings-base bg-new-beginnings-tints-800 text-new-beginnings-base shadow-primary-button",
        loading: true,
        variant: "primary",
      },
      {
        className:
          "bg-new-beginnings-tints-800 text-new-beginnings-base shadow-primary-button",
        loading: true,
        variant: "secondary",
      },
      {
        className: "bg-new-beginnings-tints-800 shadow-primary-button",
        loading: true,
        variant: "outline",
      },
      {
        className: "bg-friendly-tints-800 shadow-primary-button",
        loading: true,
        variant: "friendly",
      },
    ],
    defaultVariants: {
      size: "primary",
      variant: "primary",
    },
    variants: {
      loading: {
        false: "",
        true: "", // Placeholder, actual styles in compoundVariants
      },
      size: {
        icon: "h-10 w-10",
        lg: "h-11 rounded-full px-8",
        primary: "h-12 px-6 py-2",
        sm: "h-9 rounded-md px-3",
        xl: "h-14 rounded-full px-6 font-bold text-[1.125rem] leading-9",
      },
      variant: {
        blank: `bg-transparent rounded-full w-10 h-10
          hover:border-2 hover:border-new-beginnings-base hover:shadow-primary-button
          focus:outline focus:outline-2 focus:outline-new-beginnings-base`,
        "chevron-right": `focus:text-support-tints-400  rounded-l-sm rounded-r-none justify-start`,
        dot: `outline-offset-4 rounded-full w-2 h-2 mr-4 bg-new-beginnings-base focus:outline focus:outline-2 focus:outline-new-beginnings-base`,
        friendly: `bg-friendly-base text-new-beginnings-base 
          border-2 border-transparent
          hover:bg-friendly-tints-800 hover:shadow-primary-button
          focus:outline focus:outline-2 focus:border-2 focus:border-transparent focus:outline-friendly-base`,
        ghost: `text-new-beginnings-base 
          hover:bg-new-beginnings-tints-800 hover:shadow-primary-button
          focus:outline focus:outline-2 focus:outline-new-beginnings-base disabled:opacity-50`,
        outline: `border-2 border-new-beginnings-base text-new-beginnings-base bg-background 
          hover:bg-new-beginnings-tints-800 hover:shadow-primary-button
          focus:outline focus:outline-2 focus:border-2 focus:border-transparent focus:outline-new-beginnings-base`,
        "outline-light": `border-2 border-white text-white bg-transparent 
          hover:bg-white hover:text-new-beginnings-base hover:shadow-primary-button
          focus:outline focus:outline-2 focus:border-2 focus:border-transparent focus:outline-white`,
        "outline-secondary": `border-2 border-support-tints-400 text-new-beginnings-base bg-background 
          hover:bg-new-beginnings-tints-800 hover:shadow-primary-button hover:text-new-beginnings-base
          focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-support-tints-400`,
        plain: "",
        primary: `bg-new-beginnings-base text-support-base 
          border-2 border-transparent disabled:bg-new-beginnings-tints-900 disabled:text-new-beginnings-base
          hover:bg-new-beginnings-tints-800 hover:text-new-beginnings-base hover:shadow-primary-button hover:border-new-beginnings-base hover:border-2
          focus:outline focus:outline-2 focus:border-2 focus:border-transparent focus:outline-new-beginnings-base`,
        secondary: `bg-white text-new-beginnings-base 
          hover:bg-new-beginnings-tints-800 hover:text-new-beginnings-base hover:shadow-primary-button
          focus:outline focus:outline-2 focus:border-2 focus:border-transparent focus:outline-new-beginnings-base`,
      },
    },
  },
);

export type ButtonVariantProps = VariantProps<typeof buttonVariants>;
